import { NgModule }            from '@angular/core';
import { AssignmentsService }  from './assignments.service';

@NgModule({
  providers: [AssignmentsService]
})
export class AssignmentModule { }
